import { render, staticRenderFns } from "./DetalheAgendaExterno.vue?vue&type=template&id=be8362e0&scoped=true"
import script from "./DetalheAgendaExterno.vue?vue&type=script&lang=js"
export * from "./DetalheAgendaExterno.vue?vue&type=script&lang=js"
import style0 from "./DetalheAgendaExterno.vue?vue&type=style&index=0&id=be8362e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8362e0",
  null
  
)

export default component.exports